export const HOME = "Dashboard"
export const GATE = "Visitor Management"
export const ENTRY_LOG = "Entry Log"
export const KEYS = "Keys"
export const FREQUENT_VISITORS = "Frequent Visitors"
export const BLOCKED_LIST = "Blocked List"
export const VENDORS = "Vendors"
export const ENFORCEMENT = "Community Enforcement"
export const INCIDENTS = "Incident Management"
export const VIOLATIONS = "Violations"
export const ANALYTICS = "Reporting"
export const USERS = "Directory"
export const UNITS = "Units"
export const RESIDENT_DIRECTORY = "Users"
export const VEHICLES = "Vehicles"
export const PETS = "Pets"
export const SUPPORT = "Settings"
export const MAINTENANCE = "Maintenance"
export const EVENTSANDCOMMUNICATIONS = "Events & Communication"
export const ACCOUNTING = "Accounting"
export const EVENTS = "Event List"
export const CALENDAR = "Calendar"




export const NAVIGATION_ITEM_SELECTED = "navigationItemSelected";
export const ACTION_INVALID = "This action is invalid!"
export const CREATE_VISITOR_MODAL = "create-visitor-modal"
export const CREATE_VISITOR_SELECTOR_MODAL = "create-visitor-selector-modal"
export const CREATE_ENTRY_LOG_MODAL = "create-entry-log-modal"
export const CREATE_KEY_MODAL = "create-key-modal"
export const CREATE_PARTY_KEY_MODAL = "create-party-key-modal"
export const CREATE_FREQUENT_VISITOR_MODAL = "create-frequent-visitor-modal"
export const CREATE_BLOCKED_VISITOR_MODAL = "create-blocked-visitor-modal"
export const CREATE_INCIDENT_MODAL = "create-incident-modal"
export const CREATE_VIOLATION_MODAL = "create-violation-modal"
export const CREATE_USERS_MODAL = "create-users-modal"
export const CREATE_VEHICLE_MODAL = "create-vehicle-modal"
export const CREATE_PET_MODAL = "create-pet-modal"
export const CREATE_VENDOR_MODAL = "create-vendor-modal"
export const CREATE_MAINTENANCE_MODAL = "create-maintenance-modal"
export const SCAN_KEY_MODAL = "scan-key-modal"
export const INCIDENT_MODAL = "incident-modal"
export const UNIT_MODAL = "unit-modal"
export const GATE_MODAL = "gate-modal"
export const UPDATE_INCIDENT_MODAL_DATA = "update-incident-modal-data"
export const UPDATE_KEY_MODAL_DATA = "update-key-modal-data"
export const DEFAULT_CARD_INFO = [
    {
        title: "Total Keys Sent",
        value: "70",
        filters: {

        }
    },
    {
        title: "Total Keys Validated",
        value: "30",
        filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "VALIDATED",
            startTime: null,
            endTime: null
        }
    },
    {
        title: "Total Keys Pending",
        value: "3",
    },
    {
        title: "Total Keys Denied",
        value: "1",
    },
    {
        title: "Party Keys Created",
        value: "30",
        filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "CREATED",
            startTime: null,
            endTime: null
        }
    }
]